// extracted by mini-css-extract-plugin
export default {"checkBoxLabel":"checkbox_checkBoxLabel__VwGAg"};